import {twMerge} from 'tailwind-merge';

type Props = {
  className?: string;
  children?: React.ReactNode;
};

const Skeleton = ({className, children}: Props) => {
  return (
    <div className={twMerge(['bg-(--subtle-color) rounded-md w-[60%] h-[20px] my-[3px] animate-pulse', className])}>
      {children}
    </div>
  );
};

export default Skeleton;
